import CannedBeansProduct from 'models/CannedBeansProduct'

export const packagingInitialState = {
  category: CannedBeansProduct.category,
  subCategory: CannedBeansProduct.subCategory,
  SaltContent: {
    value: '',
    label: 'Salt Content',
  },
  PBContainerSize: '',
}

export const saltContentOptions = [
  {
    value: '',
    label: 'Salt Content',
    isDisabled: true,
  },
  {
    value: 'No Salt Added',
    label: 'No Salt Added',
  },
  {
    value: 'Regular',
    label: 'Regular',
  },
  { value: 'Low Sodium', label: 'Low Sodium' },
]
